import { Heading as HeadingPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Heading = React.forwardRef(({ scale, className, children, ...props }, ref) => {
    return (React.createElement(HeadingPrimitive, { className: cn("in-heading", scale ? `in-heading--${scale}` : "", className), ref: ref, ...props }, children));
});
Heading.displayName = "Heading";
export { Heading };
//# sourceMappingURL=heading.js.map